import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PermissionState } from '../reducers/permission.reducer';

 
export const selectPermissionState =
  createFeatureSelector<PermissionState>('permission');

 
export const selectPermissionsData = createSelector(
  selectPermissionState,
  (state) => state.data || []
);

 
export const selectAllPermissionCodes = createSelector(
  selectPermissionsData,
  (data) => {
    if (!Array.isArray(data) || data.length === 0) {
      return [];
    }
    return data
      .map((permission: unknown) => {
        if (typeof permission === 'string') {
          return permission.trim();
        }
        if (permission && typeof permission === 'object' && 'code' in permission) {
          return String((permission as { code?: unknown }).code ?? '').trim();
        }
        return '';
      })
      .filter((code) => code.length > 0);
  },
);

 
export const selectHasPermission = (code: string) =>
  createSelector(selectAllPermissionCodes, (codes) => codes.includes(code));

 
export const selectPermissionsLoading = createSelector(
  selectPermissionState,
  (state) => state.loading
);
